<template>
  <div class="change-photo">
    <Back @goBack="goUserInfo" />
    <div class="content-box">
      <div class="left">
        <div class="img-box">
          <div class="whl-headwear-box">
            <!--头像-->
            <img
              class="cur-photo"
              :src="curItem ? curItem.avatar_url : user_photo"
              alt=""
              ondragstart="return false;"
            />
            <!--头饰-->
<!--            <img :src="currentHeadwear.imageUrl ? currentHeadwear.imageUrl : ''" alt="" v-if="JSON.stringify(currentHeadwear) != '{}' && currentHeadwear.imageUrl">-->
          </div>
          <p class="cur-text">当前头像</p>
        </div>
      </div>
      <div class="right">
        <div class="whl-tab">
          <ul>
            <li v-for="(item, index) in tabList" :key="item.id" ref="tab" @click="tabClick(index)" :class="tabCurrentIndex == index ? 'whl-tab-chossed' : ''">{{item.value}}</li>
          </ul>
          <i class="whl-choosed-line" :style="{transform:'translateX('+tabLinePositionDatas[tabCurrentIndex]+'px)'}"></i>
        </div>
        <!--头像列表-->
        <div class="right-con" v-if="tabCurrentIndex === 0">
          <div
            class="item-img cursor"
            v-for="(item, index) in imgArr"
            :key="index"
            :class="[
              index % 5 == 0 ? '' : '',
              (index + 1) % 5 == 0 ? 'mr0' : '',
            ]"
            @click="checkPhoto(item, index)"
          >
            <div class="left-img-box">
              <img
                class="photo-src"
                :src="item.avatar_url"
                alt=""
                ondragstart="return false;"
              />
              <div class="left-mask"></div>
            </div>
            <img
              class="right-icon"
              :src="rightIcon"
              alt=""
              v-if="curIndex == index"
              ondragstart="return false;"
            />
          </div>
        </div>
        <!--头饰列表-->
        <div class="whl-headdress-container" v-else>
          <div >
            <img src="../../../assets/img/userinfo/no-head-img.png" alt="" ondragstart="return false;" @click="checkHeadwear({})">
            <img :src="rightIcon" v-if="currentHeadwearId === 0 || currentHeadwearId === null" />
          </div>
          <div v-for="item in headwearList" :key="item.id" @click="checkHeadwear(item)">
            <img :src="item.imageUrl" alt="" ondragstart="return false;">
            <img :src="rightIcon" v-if="currentHeadwearId == item.id" />
            <i v-if="item.day!=-1 && item.day<=15" :class="{'i_red':item.day<=3}" v-text="item.day==0?'当日失效':`剩余${item.day}天`"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "@/components/basic/back.vue";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "changePhoto",
  data() {
    return {
      rightIcon: "/static/img/userInfo/right-icon.png",
      imgArr: [],
      curIndex: null,
	    curItem: "",
      defaultIndex:null,
      defaultHeadwearId:0,
      tabList: [
        {id: 1, value: '头像'},
        // {id: 2, value: '头饰'}
      ],
      tabLinePositionDatas: [17],
      tabCurrentIndex: 0,
      headwearList: [],
      currentHeadwear: {},
      currentHeadwearId: null
    };
  },
  components: {
    Back,
  },
  created() {},
  mounted() {
    this.getPhotoList();
    this._dealTab();
    // this._getHeadwear()
  },
  computed: {
    ...mapState(["user_photo","userHeadwear"]),
  },
  methods: {
    ...mapActions(["getDefaultPhotoList", "getHeadwearList","updateHeadwear"]),
    checkHeadwear(item) {
      if(JSON.stringify(item) != '{}') {
        this.currentHeadwear = item;
        this.currentHeadwearId = item.id;
      }else {
        this.currentHeadwear = {};
        this.currentHeadwearId = 0;
      }
    },
    _dealTab() {
      let resultPositionDatas = [];
      let itemArr = [];
      itemArr = this.$refs.tab || [];
      itemArr.forEach(item => {
        resultPositionDatas.push(item.offsetLeft + (item.offsetWidth - 24) / 2);
      });
      this.tabLinePositionDatas = resultPositionDatas;
    },
    tabClick(index) {
      this.tabCurrentIndex = index;
    },
    _getHeadwear() {
      this.getHeadwearList({}).then(({res, ok})=> {
        if(!ok) return;
        for(let v of res) {
          if(v.isCheck == 1) {
            this.currentHeadwearId = v.id;
            this.currentHeadwear = v;
            this.defaultHeadwearId = v.id;
          }
        }
        this.headwearList = res;
      })
    },
    //返回到个人中心主页面
    goUserInfo() {
      let query = {};
      let currentHeadwearId = this.currentHeadwearId;
      if (this.curItem != "" && this.defaultIndex!==this.curIndex) {
        let str = this.curItem.avatar_url;
        let id = str.slice(str.lastIndexOf("/") + 1);
        query.photoId = id;
      }
      if(currentHeadwearId !== null && this.defaultHeadwearId!=currentHeadwearId) {
        query.headwearId = currentHeadwearId;
      }
      this.$router.replace({ path: "/userInfo", query });
    },
    //点击头像
    checkPhoto(item, index) {
      this.curIndex = index;
      this.curItem = item;
    },
    //获取头像数据
    getPhotoList() {
      this.getDefaultPhotoList({}).then(({res,ok}) => {
        if(!ok) return;
        this.imgArr = res;
        this.curItem = res.filter((item, index) => {
        if (item.is_check == 1) {
          this.curIndex = index;
          this.defaultIndex = index;
          return true
        }
        })[0];
      });
    },
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.change-photo {
  height: 100%;
  width: 100%;
  overflow: hidden;
  .content-box {
    height: 100%;
    width: 100%;
    display: flex;
    .left {
      width: 30%;
      height: 100%;
      background: #0080c9;
      .img-box {
        width: 100%;
        height: auto;
        overflow: hidden;
        margin-top: 225px;
        display: flex;
        align-items: center;
        flex-direction: column;
        .whl-headwear-box {
          width: 256px;
          height: 256px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          &>img:first-child {
            border: 4px solid #fff;
            height: 156px;
            width: 156px;
            box-sizing: border-box;
            border-radius: 50%;
          }
          &>img:nth-child(2) {
            width: 256px;
            height: 256px;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        p {
          font-size: 24px;
          margin-top: -35px;
          color: #6dc1d9;
        }
      }
    }
    .right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      height: 100%;
      background: #008fd8;
      .whl-tab {
        width: 225px;
        height: 75px;
        display: flex;
        font-weight: 600;
        color: rgba(255,255,255,.7);
        font-size: 24px;
        position: relative;
        margin: 0 auto;
        margin-top: 50px;
        &>ul {
          height: 75px;
          list-style: none;
          display: flex;
          justify-content: center;
          align-items: center;
          &>li {
            width: 50px;
            margin: 0 32px;
            cursor: pointer;
          }
          &>li.whl-tab-chossed {
            color: #fff;
          }
        }
        .whl-choosed-line {
          position: absolute;
          top: 71px;
          display: inline-block;
          height: 2px;
          width: 26px;
          border-radius:20px;
          background: #fff;
          transition: all 0.3s;
        }
      }
      .right-con {
        max-width: 800px;
        position: relative;
        margin-top: 98px;
        text-align: left;
        .item-img {
          height: 84px;
          width: 84px;
          display: inline-block;
          margin-right: 30px;
          margin-bottom: 80px;
          border-radius: 50%;
          border: 3px solid #0073b5;
          position: relative;
          .left-img-box {
            position: relative;
            height: 100%;
            width: 100%;
            border-radius: 50%;
            .photo-src {
              position: absolute;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              left: 0;
              top: 0;
              z-index: 1;
            }
            &:hover {
              .left-mask {
                height: 100%;
                width: 100%;
                position: absolute;
                z-index: 2;
                background: rgba(0, 48, 87, 0.4);
                border-radius: 50%;
              }
            }
          }

          .right-icon {
            position: absolute;
            width: 27px;
            height: 27px;
            z-index: 3;
            right: 0px;
            bottom: 0px;
            @media screen and (min-width: 1921px) {
              width: 41px;
              height: 41px;
            }
          }
        }

      }
      .whl-headdress-container {
        max-width: 740px;
        height: auto;
        overflow: hidden;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 53px;
        &>div {
          width: 164px;
          height: 164px;
          margin:0 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          &>img:first-child {
            width: 100%;
            height: 100%;
          }
          &>img:nth-child(2) {
            position: absolute;
            width: 27px;
            height: 27px;
            z-index: 3;
            right: 28px;
            bottom: 30px;
            @media screen and (min-width: 1921px) {
              width: 41px;
              height: 41px;
            }
          }
        }
        i{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          width: 75px;
          height: 22px;
          background: rgba(255,255,255,.6);
          border-radius: 12px;
          font-size: 12px;
          line-height: 22px;
          text-align: center;
          font-weight: 600;
          color: #00466a;
        }
        .i_red{
          color: #C81A1A;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/userInfo/changePhoto.vue